import React from 'react';
import styled from 'styled-components';
import { skills } from '../../data/constants';
import { useLanguage } from '../../utils/LanguageContext';

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
position: relative;
z-index: 1;
`;

const Wrapper = styled.div`
  max-width: 1100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

const Title = styled.h1`
font-size: 42px;
font-weight: 700;
text-align: center;
margin-top: 20px;
color: ${({ theme }) => theme.text_primary};

@media (max-width: 768px) {
  margin-top: 12px;
  font-size: 32px;

}
`;

const Desc = styled.div`
font-size: 18px;
max-width: 600px;
text-align: center;
color: ${({ theme }) => theme.text_secondary};
padding: 0 16px;

@media (max-width: 768px) {
  font-size: 16px;
}
`;

const SkillsContainer = styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
margin-top: 30px;
justify-content: center;
gap: 30px;
padding: 0 16px;

@media (max-width: 768px) {
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  justify-content: flex-start;
  padding: 0 20px 12px 25px;
  gap: 16px;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.primary + '60'} transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.primary + '60'};
    border-radius: 4px;
  }
}
`;

const Skill = styled.div`
width: 100%;
max-width: 500px;
background-color: ${({ theme }) => theme.card};
border: 0.1px solid #854CE6;
border-radius: 16px;
padding: 18px 36px;

@media (max-width: 768px) {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 80vw;
  max-width: 320px;
  padding: 18px 24px;

}
`;

const SkillTitle = styled.h2`
font-size: 28px;
font-weight: 600;
color: ${({ theme }) => theme.text_secondary};
margin-bottom: 20px;
text-align: center;
`;

const SkillList = styled.div`
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 12px;
margin-bottom: 20px;
`;

const SkillItem = styled.div`
display: flex;
align-items: center;
gap: 8px;
justify-content: center;
font-size: 16px;
color: ${({ theme }) => theme.text_primary + 80};
border: 1px solid ${({ theme }) => theme.text_primary + 80};
border-radius: 12px;
padding: 12px 16px;
font-weight: 400;

@media (max-width: 768px) {
  font-size: 14px;
  padding: 8px 12px;
}

@media (max-width: 500px) {
  font-size: 14px;
  padding: 6px 12px;
}
`;

const SkillImage = styled.img`
width: 24px;
height: 24px;
`;


const Skills = () => {
  const { t } = useLanguage();

  return (
    <Container id="skills">
      <Wrapper>
        <Title>{t.skills}</Title>
        <Desc>{t.skillsDesc}</Desc>
        <SkillsContainer>
          {skills.map((item, index) => (
            <Skill key={index}>
              <SkillTitle>{item.title}</SkillTitle>
              <SkillList>
                {item.skills.map((skill, idx) => (
                  <SkillItem key={idx}>
                    <SkillImage src={skill.image} alt={skill.name} loading="lazy" />
                    {skill.name}
                  </SkillItem>
                ))}
              </SkillList>
            </Skill>
          ))}
        </SkillsContainer>
      </Wrapper>
    </Container>
  )
}

export default Skills
